/* eslint-disable */
import * as Types from '../../../../graphql/generated';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';


export type FbCurrencyAllFragment = { readonly __typename?: 'fbCurrency', readonly facebookCurrency?: string | null, readonly facebookCurrencyMinValue?: number | null, readonly facebookCurrencyOffset?: number | null, readonly facebookCurrencySymbol?: string | null };

export type AdminMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;

export type AdminMetadataQueryFbAdminMetaData = {
	readonly __typename?: 'fbAdminMetaData',
	readonly adminId?: number | null,
	readonly adminName?: string | null,
	readonly externalAdvertisers?: ReadonlyArray<string | null> | null,
	readonly environment?: string | null,
	readonly timezone?: string | null,
	readonly network?: string | null,
	readonly global_network?: string | null,
	readonly culture?: string | null,
	readonly credentials?: ReadonlyArray<string | null> | null,
	readonly locale?: any | null,
	readonly oauthUserId?: number | null,
	readonly email?: string | null 
}

export type AdminMetadataQueryFbCurrencies = {
	readonly __typename?: 'fbCurrency',
	readonly facebookCurrency?: string | null,
	readonly facebookCurrencyMinValue?: number | null,
	readonly facebookCurrencyOffset?: number | null,
	readonly facebookCurrencySymbol?: string | null 
}

export type AdminMetadataQuery = {
	readonly __typename?: 'Query',
	readonly fbAdminMetaData?: AdminMetadataQueryFbAdminMetaData | null,
	readonly fbCurrencies?: ReadonlyArray<AdminMetadataQueryFbCurrencies | null> | null 
};

export type UserMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;

export type UserMetadataQueryCredentials = {
	readonly __typename?: 'credentials',
	readonly name?: string | null,
	readonly read?: boolean | null,
	readonly write?: boolean | null,
	readonly delete?: boolean | null 
}

export type UserMetadataQueryCustomers = {
	readonly __typename?: 'customers',
	readonly customerId?: string | null,
	readonly customerEmail?: string | null,
	readonly customerFullName?: string | null 
}

export type UserMetadataQueryFbUsers = {
	readonly __typename?: 'fbTaUser',
	readonly userId?: any | null,
	readonly userFullName?: any | null,
	readonly userName?: any | null,
	readonly userSurname?: any | null,
	readonly userCompanyName?: any | null,
	readonly userEmail?: any | null,
	readonly userIsActivated?: any | null,
	readonly userIsDeleted?: any | null,
	readonly userIsValidated?: any | null,
	readonly userTourFinished?: any | null,
	readonly id?: any | null,
	readonly credentials?: ReadonlyArray<UserMetadataQueryCredentials | null> | null,
	readonly customers?: ReadonlyArray<UserMetadataQueryCustomers | null> | null 
}

export type UserMetadataQueryLocaleMetadata = {
	readonly __typename?: 'localeMetadata',
	readonly locale?: any | null,
	readonly timezone?: string | null 
}

export type UserMetadataQueryFbCurrencies = {
	readonly __typename?: 'fbCurrency',
	readonly facebookCurrency?: string | null,
	readonly facebookCurrencyMinValue?: number | null,
	readonly facebookCurrencyOffset?: number | null,
	readonly facebookCurrencySymbol?: string | null 
}

export type UserMetadataQuery = {
	readonly __typename?: 'Query',
	readonly fbUsers?: ReadonlyArray<UserMetadataQueryFbUsers | null> | null,
	readonly localeMetadata?: UserMetadataQueryLocaleMetadata | null,
	readonly fbCurrencies?: ReadonlyArray<UserMetadataQueryFbCurrencies | null> | null 
};
export const FbCurrencyAllFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fbCurrencyAll"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fbCurrency"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facebookCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"facebookCurrencyMinValue"}},{"kind":"Field","name":{"kind":"Name","value":"facebookCurrencyOffset"}},{"kind":"Field","name":{"kind":"Name","value":"facebookCurrencySymbol"}}]}}]} as unknown as DocumentNode<FbCurrencyAllFragment, unknown>;
export const AdminMetadataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"adminMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fbAdminMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminId"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"externalAdvertisers"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"global_network"}},{"kind":"Field","name":{"kind":"Name","value":"culture"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"oauthUserId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fbCurrencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fbCurrencyAll"}}]}}]}},...FbCurrencyAllFragmentDoc.definitions]} as unknown as DocumentNode<AdminMetadataQuery, AdminMetadataQueryVariables>;
export const UserMetadataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fbUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userFullName"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userIsActivated"}},{"kind":"Field","name":{"kind":"Name","value":"userIsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"userIsValidated"}},{"kind":"Field","name":{"kind":"Name","value":"userTourFinished"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"write"}},{"kind":"Field","name":{"kind":"Name","value":"delete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"customerFullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"localeMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fbCurrencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fbCurrencyAll"}}]}}]}},...FbCurrencyAllFragmentDoc.definitions]} as unknown as DocumentNode<UserMetadataQuery, UserMetadataQueryVariables>;